// /app/page.tsx
"use client";

import LoginPage from "@/app/login/page";
import React, { useEffect } from "react";
import CookieSessionManager from "@/app/services/session.client";

const LaunchPage: React.FC = () => {
  useEffect(() => {
    // const savedFontSizes = sessionStorage.getItem("FontSizes");
    const savedFontSizes: any =
      CookieSessionManager.getDataFromBrowserSession("FontSizes");
    //Font sizes is a json with format { title:"2rem",subtitle:"1.5rem",body:"14px"}
    if (savedFontSizes) {
      const fontSizes = JSON.parse(savedFontSizes);
      document.documentElement.style.setProperty(
        "--title-font-size",
        fontSizes.title,
      );
      document.documentElement.style.setProperty(
        "--subtitle-font-size",
        fontSizes.subtitle,
      );
      document.documentElement.style.setProperty(
        "--body-font-size",
        fontSizes.body,
      );
    }
  }, []);

  return (
    <div className="overflow-x-hidden ">
      <LoginPage />
    </div>
  );
};

export default LaunchPage;
